const counter = () => {
  const countersSection = document.querySelector(".counters")

  if (!countersSection) return

  const counters = document.querySelectorAll(".counters__counter")
  counters.forEach((counter) => {
    counter.innerText = "0"
  })

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          counters.forEach((counter) => {
            if (counter) {
              const updateCounter = () => {
                const target = +counter.getAttribute("data-counter")
                const c = +counter.innerText
                const increment = target / 250

                if (c < target) {
                  counter.innerText = `${Math.ceil(c + increment)}`
                  setTimeout(updateCounter, 1)
                } else {
                  counter.innerText = target
                }
              }

              updateCounter()
            }
          })
          observer.unobserve(entry.target)
        }
      })
    },
    {
      rootMargin: "0px 0px -300px 0px",
    }
  )
  observer.observe(countersSection)
}
export default counter
